// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3rTMO","content":"LoadingAlert_content__3Qbur"};